import { Link } from "react-router-dom";
import { topics } from "@/mocks/content";

export default function TopicSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="mb-8">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 flex items-center gap-2">
          <i className="ri-bookmark-3-line text-primary-500" />
          编辑精选专题
        </h2>
        <p className="text-sm text-foreground-600 mt-2">
          我们帮你把同一主题的快乐打包好了，点进去一次看个够。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {topics.map((topic, i) => (
          <Link
            key={topic.id}
            to={topic.contentIds.length > 0 ? `/detail/${topic.contentIds[0]}` : "/"}
            className={`group relative rounded-lg overflow-hidden ${
              i === 0 ? "md:col-span-3 h-64 md:h-72" : "h-64 md:h-72"
            }`}
          >
            <img
              src={topic.cover}
              alt={topic.title}
              title={`${topic.title} - 羞羞网站专题`}
              className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent" />
            <div className="relative z-10 h-full p-5 md:p-6 flex flex-col justify-end">
              <span className="inline-flex w-fit items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-3">
                <i className="ri-sparkling-2-line" />
                专题合集
              </span>
              <h3 className="font-heading font-bold text-xl text-background-50">{topic.title}</h3>
              <p className="text-background-50/80 text-xs md:text-sm mt-2 max-w-xl line-clamp-2">
                {topic.description}
              </p>
              <span className="inline-flex items-center gap-1 text-primary-300 text-sm font-medium mt-3">
                进入合集 · {topic.contentIds.length} 条内容
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}